import { serviceSystemMonitoringApiSlice as api } from "../../../apiSlice";
export const addTagTypes = ["General Quality of Service"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAllGeneralQosGeneralQosGet: build.query<
        GetAllGeneralQosGeneralQosGetApiResponse,
        GetAllGeneralQosGeneralQosGetApiArg
      >({
        query: () => ({ url: `/general_qos` }),
        providesTags: ["General Quality of Service"],
      }),
      getGeneralQosGeneralQosAccountIdGet: build.query<
        GetGeneralQosGeneralQosAccountIdGetApiResponse,
        GetGeneralQosGeneralQosAccountIdGetApiArg
      >({
        query: (queryArg) => ({ url: `/general_qos/${queryArg.accountId}` }),
        providesTags: ["General Quality of Service"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as serviceSystemMonitoringOpenApi };
export type GetAllGeneralQosGeneralQosGetApiResponse =
  /** status 200 Successful Response */ GeneralQoSAllResponse;
export type GetAllGeneralQosGeneralQosGetApiArg = void;
export type GetGeneralQosGeneralQosAccountIdGetApiResponse =
  /** status 200 Successful Response */ GeneralQoSResponse;
export type GetGeneralQosGeneralQosAccountIdGetApiArg = {
  /** The account ID to retrieve GeneralQualityOfService records for. */
  accountId: number;
};
export type GeneralQoSRecord = {
  /** The account ID. */
  accountId: string;
  /** The alarm config ID. */
  alarmConfigId: string;
  /** The unit ID. */
  unitId: number;
  /** The unit type input ID. */
  unitTypeInputId: number;
  /** The data type (e.g. 'heat-consumption'). */
  dataType: string;
  /** The aggregation window type (e.g. 'Day'). */
  aggregateType: string;
  /** The rolling window size in days. */
  window: number;
  /** The data offset in days. */
  offset: number;
  /** The minimum acceptable data ratio threshold. */
  threshold: number;
  /** The actual data ratio within the window. */
  dataRatio: number;
  /** Whether dataRatio is at or above the threshold. */
  aboveThreshold: boolean;
  /** The unit name. */
  unitName?: string | null;
};
export type GeneralQoSAllResponse = {
  /** All GeneralQualityOfService records across all accounts. */
  records: GeneralQoSRecord[];
};
export type GeneralQoSResponse = {
  /** The account ID the records belong to. */
  accountId: number;
  /** All GeneralQualityOfService records for the account. */
  records: GeneralQoSRecord[];
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
  input?: any;
  ctx?: object;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export const {
  useGetAllGeneralQosGeneralQosGetQuery,
  useGetGeneralQosGeneralQosAccountIdGetQuery,
} = injectedRtkApi;
